import React, { useEffect, useState } from 'react';
import NtxTable from '../../../../components/DataTable/NtxTable';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useGetPayrolls from '../../../../hooks/HR/useGetPayrolls';
import Select from 'react-select';
import { Card, CardBody } from '../../../../components/card/card';
import Loading from '../../../../components/Shared/Loader/Loading';
import {
  DeletePayrollAction,
  GetPayrollActionList,
  cleanUpPayrollActionList,
  sendPayrollActionToAme
} from '../../../../store/HR/Payroll/runPayrollSlice';
 import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import NeatixModal from '../../../../components/Modal/NeatixModal';
import CreateAccount from './CreateAccount';
import { useNavigate } from 'react-router-dom';
 import { usePermissions } from '@Helper/Permisstions/usePermissions';
const ShowPayrollRun = () => {
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState('');
  const [payrollId, setPayrollId] = useState(null);
  const [payrollAction, setPayrollAction] = useState();
  const [show, setShow] = useState(false);
  const Navigate = useNavigate();
  const {HasPermission} = usePermissions()
  const { PayrollsOptions } = useGetPayrolls();
  const dispatch = useDispatch();

  const {
    PayrollActionList,
    loadingActionList: loading,
    errorActionList: error
  } = useSelector(state => state.runPayroll);

  useEffect(() => {
    if (payrollId) {
      dispatch(GetPayrollActionList(payrollId));
    }

    return () => {
      dispatch(cleanUpPayrollActionList());
    };
  }, [dispatch, payrollId]);

  console.log(JSON.stringify(PayrollActionList, null, 2));

  const DataByPayroll = PayrollActionList?.slice()
    ?.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
    ?.filter(item => {
      const searchLowerCase = search.toLowerCase();
      return item.name?.toLowerCase().toString().includes(searchLowerCase);
    });

  const columns = [
    { title: t('Period-Month'), key: 'Name' },
    { title: t('TypeRunPayroll'), key: 'type' },
    { title: t('StartOfPeriod'), key: 'start' },
    { title: t('EndOfPeriod'), key: 'End' },
    { title: t('Date'), key: 'data' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = DataByPayroll?.map(item => {

    let badgeColor = 'secondary';
    let badgeLabel = '';
  
    switch (item.actionType) {
      case 'QuickPay':
        badgeColor = 'primary';
        badgeLabel = t('_Quick');
        break;
      case 'PartialRun':
        badgeColor = 'warning';
        badgeLabel = t('Partial');
        break;
      case 'Run':
        badgeColor = 'success';
        badgeLabel = t('All');
        break;
      default:
        badgeLabel = item.actionType;
    }
  
    // let rowClass;
    return {
      Name: item.name,
      // type: item.actionType,
      type: (
        <span className={`badge bg-${badgeColor}`}>
          {badgeLabel}
        </span>
      ),
      start: item.startDate,
      End: item.endDat,
      data: item.creationDate,
      action: (
        <div className='btn-group px-2'>
          {item.statusName === 'New' && (
            <>
              <button
                type='button'
                className='btn btn-sm btn-theme  m-0'
                onClick={() => handleSendPayrollActionToAme(item)}
              >
                <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
                {t('إرسال للإعتماد')}
              </button>
              <button
                type='button'
                className='btn btn-sm btn-danger m-0'
                onClick={() => handleDeletePayrollAction(item)}
              >
                <i className='fas fa-trash-alt fa-fw fa-lg'></i>
                {t('Button.Delete')}
              </button>
            </>
          )}
          {item.statusName === 'ToPost' && (
            <button
              type='button'
              className='btn btn-sm btn-success m-0'
              // data-bs-toggle="modal"
              // data-bs-target="#CreateAccountModal"
              // onClick={() => handleCeateAccount(item)}
              onClick={() => {
                setShow(true);
                setPayrollAction(item);
              }}
            >
              <i className='fas fa-lg fa-fw me-2 fa-paper-plane'></i>
              {t('ترحيل الراتب')}
            </button>
          )}
          {HasPermission('PayPayrollRunList') && (
            <button
              type='button'
              onClick={() =>
                Navigate(`${item.id}/AssignmentActionList`, {
                  state: { ReferenceName: item.name }
                })
              }
              className='btn btn-sm btn-outline-theme ms-1'
            >
              <i className='fas fa-lg fa-fw me-2 fa-file-invoice-dollar'></i>
              {t('عرض التفـاصيـل')}
              {/* {t('SalaryStatement')}  كشف الراتب*/}
            </button>
          )}
        </div>
      )
    };
  });

  // Handele Delete Payroll Action
  const handleDeletePayrollAction = item => {
    showConfirmation(t('MsgConfirm'), async () => {
      await dispatch(DeletePayrollAction(item.id))
        .unwrap()
        .then(() => {
          console.log(payrollId);
          debugger;
          dispatch(GetPayrollActionList(payrollId));
          CustomAlert({ action: 'Delete' });
        })
        .catch(error => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  // Handele Send PayrollAction T oAme
  const handleSendPayrollActionToAme = item => {
    showConfirmation('هل أنت متــأكد من إرسال هذا هذا الراتب ؟', async () => {
      await dispatch(sendPayrollActionToAme(item.id))
        .unwrap()
        .then(res => {
          if (res === false) {
            CustomAlert({
              action: 'Error'
            });
          } else {
            dispatch(GetPayrollActionList(payrollId));
            CustomAlert({
              action: 'Add',
              msg: `تم ارسال الراتب  لشهر ${item.name} للموافقة عليه`
            });
          }
        })
        .catch(error => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  const titleModal = () => {
    return (
      <div className=''>
        {t('ترحيل الراتب')}
        {'  '}
        <span className='text-theme ms-2'>{`${payrollAction?.name}`}</span>
      </div>
    );
  };

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },

    {
      name: t('ShowAllRuns'),
      link: null
    }
  ];

  return (
    <>
      <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('ShowAllRuns')} />
      <Card>
        <CardBody>
          <div className='row mb-3'>
            <div className='col-lg-3'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text text-theme fw-bold'>{t('Payroll')}</span>

                <Select
                  classNamePrefix='react-select'
                  className='w-100'
                  // isLoading={loading3}
                  isSearchable={true}
                  isClearable
                  options={PayrollsOptions}
                  onChange={option => {
                    setPayrollId(option === null ? null : option.value);
                  }}
                  value={PayrollsOptions.find(f => f.value === payrollId)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
            <div className='col-lg-5'></div>
            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text  text-theme fw-bold'>
                  {t('Search')}
                  {/* <i className="fa fa-search  text-theme ms-3"></i> */}
                </span>
                <div className='input-group'>
                  <div className='flex-fill position-relative'>
                    <div className='input-group border-0 '>
                      <div
                        className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'
                         
                      >
                        <i className='fa fa-search opacity-5 text-theme'></i>
                      </div>
                      <input
                        type='text'
                        autoComplete='off'
                        className='form-control ps-35px'
                        // placeholder={t('Search')}
                        value={search}
                        onChange={e => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loading loading={loading} error={error} Type='Dots'>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>

      <NeatixModal
        show={show}
        setShow={setShow}
        size='md'
        title={titleModal()}
        headerClassName='bg-theme bg-opacity-25  p-2'
      >
        {payrollAction && <CreateAccount payrollActionId={payrollAction.id} />}
      </NeatixModal>
    </>
  );
};

export default ShowPayrollRun;
